<div class="col-12 col-lg-5 col-xl-4 mb-2">
  @if (totalSubBillerCount > 5) {
    <div class="mb-2">
      <gtapp-auto-complete
        [data]="subBillerDropDownList"
        placeHolder="Search SubBillers"
        searchKeyword="company_name"
        [itemTemplate]="subBillerTemplate"
        [initialValue]="subBillerSearchString"
        (inputChanged)="onSubBillerLookup($event)"
        (selected)="addEditSubBillerView(addEditSubBillerTemplate, $event)"
        (submitted)="
          clearValues(); subBillerSearchString = $event; getSubBillerListData()
        "
      >
      </gtapp-auto-complete>
      <ng-template #subBillerTemplate let-item>
        <div>
          {{ item?.company_name }}
        </div>
      </ng-template>
    </div>
  }

  <gtapp-gt-custom-table
    [deskTopTableData]="subBillerPaginationData[pageNumSubBillers] || []"
    [desktopTableDetails]="subBillerDetailsTableView"
    [tableStyle]="tableStyle"
    [otherParams]="otherParamsSubBillers"
    (sortColumn)="sortColumnSubBiller($event)"
    (searchColumn)="searchColumnSubBiller($event)"
    (rowClick)="addEditSubBillerView(addEditSubBillerTemplate, $event)"
    (paginationChange)="onChangePaginationSubBiller($event)"
  ></gtapp-gt-custom-table>
</div>
<div class="mt-1 mx-1">
  <div class="fixed-add-btn">
    <button
      class="btn btn-primary btn-lg w-100"
      (click)="addEditSubBillerView(addEditSubBillerTemplate)"
    >
      <span><i class="fa-solid fa-plus"></i></span>
    </button>
  </div>
</div>

<ng-template
  #addEditSubBillerTemplate
  let-addEditSubBillerTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      {{ selectedSubBillerData?.id ? "Edit Sub Biller" : "Add new Sub Biller" }}
      <span
        class="float-end"
        (click)="addEditSubBillerTemplateRef.close('close')"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <form [formGroup]="subBillerForm">
        <gtapp-input-field
          dtValue="Sub Biller Name"
          inputId="siteInputField"
          [maxLength]="256"
          [inputStringValue]="subBillerForm.value.company_name"
          (blurEmit)="subBillerForm.controls['company_name'].setValue($event)"
        >
        </gtapp-input-field>
        <div class="d-flex gap-2 my-3">
          <button
            class="btn btn-dark btn-lg w-100"
            (click)="addEditSubBillerTemplateRef.close('close')"
          >
            Cancel
          </button>
          @if (selectedSubBillerData?.id) {
            <button
              class="btn btn-danger btn-lg w-100"
              (click)="addEditSubBillerTemplateRef.close('delete')"
            >
              Delete
            </button>
          }
          <button
            class="btn btn-success btn-lg w-100"
            [disabled]="
              !subBillerForm.valid ||
              selectedSubBillerData?.company_name ==
                subBillerForm.value?.company_name
            "
            (click)="addEditSubBillerTemplateRef.close('update')"
          >
            {{
              selectedSubBillerData?.id
                ? "Update Sub Biller"
                : "Add new Sub Biller"
            }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
